import { AVAILABLE_FEATURES } from "GeneralTabAction";

export default function (
  state = [
    {
      iconName: "Schedules",
      available: true,
      bsClass: "schedule",
      description: "Schedule your event sessions.",
    },
    {
      iconName: "Speakers",
      available: true,
      bsClass: "speaker",
      description: "A list of speakers at your event with their details.",
    },
    {
      iconName: "Exhibitors",
      available: true,
      bsClass: "exhibitor",
      description: "List of event exhibitors with their details.",
    },
    {
      iconName: "Sponsors",
      available: true,
      bsClass: "sponsor",
      description: "A list of your event sponsors.",
    },
    {
      iconName: "Messages",
      available: true,
      bsClass: "message",
      description: "Allows users to chat directly with one another.",
    },
    {
      iconName: "Maps",
      available: true,
      bsClass: "maps",
      description: "Map that displays your venue and event location.",
    },
    {
      iconName: "News",
      available: true,
      bsClass: "news",
      description: "Display a list of news within your app.",
    },
    {
      iconName: "Social",
      available: true,
      bsClass: "social",
      description: "Manage social options for your event.",
    },
    {
      iconName: "About",
      available: true,
      bsClass: "about",
      description: "Display a general information about your event.",
    },
    {
      iconName: "Webview",
      available: true,
      bsClass: "webview",
      description:
        "Choose template, and make get a website on fly, it displays a web page within your app.",
    },
    {
      iconName: "Gallery",
      available: true,
      bsClass: "gallery",
      description: "Check your gallery.",
    },
    {
      iconName: "Attendees",
      available: true,
      bsClass: "attendee",
      description: "Manage attendees.",
    },
    {
      iconName: "Survey",
      available: true,
      bsClass: "survey",
      description: "Manage event survey.",
    },
    {
      iconName: "Community",
      available: true,
      bsClass: "community",
      description: "Manage community.",
    },
  ],
  action
) {
  switch (action.type) {
    case AVAILABLE_FEATURES:
      return action.payload;
    default:
      return state;
  }
}
